<script>
    import {onMount} from "svelte";
    import { getCookie, modifyCookie } from '../../../auth.js';
    import {goto, params} from "@sveltech/routify";
    import {axiosInst, loggedIn, profile,} from "../../../credentials.js";
    import Spinner from "svelte-spinner";
    import Fa from "svelte-fa";
    import {faExclamationTriangle,} from "@fortawesome/free-solid-svg-icons";
    import {CheckIcon, DownloadIcon, PlusIcon, SaveIcon,} from "svelte-feather-icons";
    import Formfield from "../../../components/Formfield.svelte";
    import {fade, slide} from "svelte/transition";
    import {checkFiles, findErrors, formatMimeType, SUPPORTED_FORMATS,} from "../../../utils/helpers.js";
    import {faFrown} from "@fortawesome/free-regular-svg-icons";
    import moment from "moment";
    import {userDetails, userDocuments} from "../../../ui-store.js";
    import Search from "../../../components/SearchComponent.svelte";
    import UserDocumentsPagination from "../../../components/UserDocumentsPagination.svelte";
    import { updateUserInfo } from "../../../services/userDocumentsService.js";
    import { findRelatedProtocolFromInstanceTags, createNewUserRequest, startNewProcessInstance, findRelatedGroupIdFromInstanceTags, findRelatedUserIdFromInstanceTags } from "../../../services/newUserRequestService.js";
    // Import the toast function
    import bulmaToast from "bulma-toast";
    

    let updateMessage = null;

    $: if (updateMessage !== null) {
      bulmaToast.setDoc(window.document);

      bulmaToast.toast({
      message: updateMessage,
      position: "top-right",
      dismissible: false,
      animate: { in: "fadeIn", out: "fadeOut" },
      duration: 5000,
      type: updateMessage.includes("Επιτυχής") ? 'is-success' : 'is-danger' 
      });
      
      setTimeout(() => {
          updateMessage = null;
        }, 5000);
      // bulmaToast.show();
    }

    // let searchWorker;
  let loadingSearch = true;

  const toggle = (index) => {
    //if index is -1, close all open requests
    if (index === -1)
      user.requests.forEach((element) => {
        element.open = false;
      });
    else {
      user.requests[index].open = !user.requests[index].open;

      user.requests.forEach((element, i) => {
        if (i !== index) element.open = false;
      });
    }
  };

  console.log(process.env.MAX_SIZE, SUPPORTED_FORMATS);
  //get values from local storage
  // loggedin.useLocalStorage();
  // loggedUser.useLocalStorage();
  // loggedUserName.useLocalStorage();

  //local testing ONLY-------------------
  //$loggedIn = true;
  //$profile.id = 1;
  //$loggedTaxis = true;

  let searchCriteria = "";
  // {
  //   serviceName: "",
  //   orgTitle: "",
  //   protocolNumber: "",
  // };

  let filteredResults = [];

  function gotoClient() {
    $goto("/client");
  }

  function howManyMinutesFromNow(date) {
    let now = moment();
    let this_date = moment(date);

    let minutes = this_date.diff(now, "minutes");
    return minutes;
  }

  $: console.log("loggedIn: ", $loggedIn);
  $: console.log("profile.id: ", $profile.id);

  const toggleRequirement = (list) => {
    list.forEach((file) => {
      if (file.obligatory) file.obligatory = false;
    });
  };

  const reset = () => {
    errorWithProcess = false;
    successfulResubmission = false;
    resubmissionMode = false;
    resetFileList(selectedCase.documentsUploaded);
    resetFileList(documentsNotUploadedToCase);
    resetFileList(additionalDocuments);
    additionalDocuments = [];
    resubmissionData = {
      protocolNumber: null,
      processInstanceIdToResubmit: null,
      variableNameToPutCurrentPid: "submitFROM",
      resubmissionSignal: "__resubmit",
      resubmissionRelationshipList: [],
    };
    isFormValid = false;
  };

  let userFound = false;
  let errors = [];

  let user = null;
  $: console.log("user: ", user);

  let activeMenu = 1;
  let selectedCase = null; //selected case to view in modal
  let ready = false; //is the selectedcaseinfo ready to be shown?

  let resubmissionMode = false; //is the user resubmitting documents to the case?
  let loading = true;
  let loadingOrgInfo = true;
  let selectedOrgDTO = null;
  let issuerQuintuplet = null;
  let serviceRequestedFiles = null;
  // $: console.log("test serviceRequestedFiles :", serviceRequestedFiles);

  //if a case is selected, compare what the user has uploaded to what the service was asking for (needed for resubmission mode)
  let documentsNotUploadedToCase = null;
  $: console.log(
    "test documentsNotUploadedToCase :",
    documentsNotUploadedToCase
  );

  //this variable is needed in order to avoid infinite loops (mainly)
  //when a case is selected, a reactive statement runs, in which we run for loops
  //to assign variableNames to uploaded documents, in case the user wants to reupload files to his case
  //so, if we have completed this crosscheck, the reactive statement won't run.
  let calledCrosscheck = false;
  $: if (selectedCase)
    console.log("selectedCase.documentsUploaded ", selectedCase);

  //if a case is selected, a number of things need to be done:
  //1)get the url where each uploaded and produced documents are stored
  //2)create their download links
  //3)add them as a field in the json arrays (easy display)
  $: if (selectedCase && !calledCrosscheck) {
    console.log(selectedCase);
    ready = false;
    getIssuerFromOrgInfo().then(() => {
      //add variable name as a field to uploaded documents' object array (in case the user wants to reupload files to his case)
      //crosscheck with data from organization to get the variable name
      // console.log(selectedCase.documentsUploaded);
      if (
        selectedCase &&
        selectedCase.documentsUploaded &&
        selectedCase.documentsUploaded.length >= 0
      ) {
        console.log("DOC NUMBER: ", selectedCase.documentsUploaded.length);
        selectedCase.documentsUploaded = crossCheckFiles(
          selectedCase.documentsUploaded,
          serviceRequestedFiles
        );
      }
      ready = true;
    });
  }

  const crossCheckFiles = (uploadedDocuments, requestedFiles) => {
    //crosscheckFiles and add variableProperty to uploeadedFiles by user
    console.log("inside crossCheck files");
    calledCrosscheck = true;
    documentsNotUploadedToCase = null;
    for (let i = 0; i < uploadedDocuments.length; i++) {
      //let title = selectedCase.documentsUploaded[i].fileTitle;
      let result = [];
      if (requestedFiles) {
        result = requestedFiles.filter(
          (file) =>
            file.fileTitle.toString() ===
            uploadedDocuments[i].fileTitle.toString()
        );
      }
      console.log(result);
      console.log("in loop");
      if (result.length) {
        uploadedDocuments[i]["mapToVariableName"] = result[0].mapToVariableName;
      } else
        uploadedDocuments[i]["mapToVariableName"] = result.mapToVariableName;
    }
    if (!requestedFiles) {
      requestedFiles = [];
    }
    documentsNotUploadedToCase = requestedFiles.filter((file) => {
      return !uploadedDocuments.some((doc) => {
        return doc.fileTitle.toString() === file.fileTitle.toString();
      });
    });

    return uploadedDocuments;
  };

  $: console.log("additionalDocuments ", additionalDocuments);
  $: console.log("documentsNotUploadedToCase ", documentsNotUploadedToCase);

  const downloadFile = (doc) => {
    console.log(doc);
    getURL(doc).then((res) => {
      createDownloadLink(res.docId, res.versionFileId).then((result) => {
        var a = document.createElement("a");
        a.href = result.downloadLink;
        //if result.type has been set, add extension to filename (for download  bug)
        a.setAttribute(
          "download",
          result.type ? doc.fileTitle + "." + result.type : doc.fileTitle
        );
        a.click();
      });
    });
  };

  const createDownloadLink = (docId, versionFileId) => {
    //response needs to be an arraybuffer, in order to build the blob url
    let fileType;
    return new Promise(async (resolve, reject) => {
      try {
        const res = await $axiosInst
          .get(
            "open1process/files/" +
              docId +
              "/version/" +
              versionFileId +
              "/content",
            {
              params: { registeredOrganizationId: selectedCase.orgId },
            },
            {
              responseType: "arraybuffer",
              transformRequest: (data, headers) => {
                delete headers["SessionID"];
                return data;
              },
            }
          )
          .then(function (response) {
            // console.log(response.status);
            if (response.status === 200) {
              console.log("successful download");
              var arr = response.data.data.content;
              var byteArray = Uint8Array.from(atob(arr), (c) =>
                c.charCodeAt(0)
              );
              var blob = new Blob([byteArray], {
                type: response.data.data.contentType,
              });
              let mimeType = formatMimeType(response.data.data.contentType);
              let downloadLink = URL.createObjectURL(blob, {
                type: response.data.data.contentType,
              });
              let result = {
                downloadLink: downloadLink,
                type: null,
              };
              //if mimetype is of certain type, add property to file (we need it for a download bug)
              if (
                mimeType === "DOC" ||
                mimeType === "DOCX" ||
                mimeType === "ODT"
              )
                result.type = mimeType.toLowerCase();
              resolve(result);
            } else {
              reject("something went wrong");
            }
          });
      } catch (e) {
        console.log(e);
        reject(e);
      }
    });
  };

  const getIssuerFromOrgInfo = () => {
    //get all org services
    return new Promise(async (resolve, reject) => {
      let serviceUuid = selectedCase ? selectedCase.serviceUuid : null;
      let orgId = selectedCase ? selectedCase.orgId : null;

      let promise = $axiosInst
        .get("registeredOrganization/" + orgId)
        .then(function (response) {
          console.log(response);
          if (response.status !== 200) {
            console.log(
              "Looks like there was a problem. Status Code: " + response.status
            );
            loadingOrgInfo = false;
            reject();
          } else {
            //If status OK, see if we have errors
            if (response.data.errors.length > 0) {
              console.log("Unathorized User" + ": " + data.errors);
              // add more actions...
              loadingOrgInfo = false;
              reject();
            } else {
              //no errors, move to next and final step
              selectedOrgDTO = response.data.data;
              console.log(selectedOrgDTO);
              console.log("success");
              //filter to find service and set issuer
              let filter = selectedOrgDTO.servicesProvided.filter(
                (service) =>
                  service.serviceUuid.toString() === serviceUuid.toString()
              );
              console.log(filter);
              if (filter.length) {
                issuerQuintuplet = filter[0].serviceIssuer;
                serviceRequestedFiles = filter[0].filesRequested;
                loadingOrgInfo = false;
                resolve();
              } else {
                issuerQuintuplet = filter.serviceIssuer;
                serviceRequestedFiles = filter.filesRequested;
                loadingOrgInfo = false;
                resolve();
              }
            }
          }
        })
        .catch(function (err) {
          console.log("Fetch Error :-S", err);
          reject();
        });
      //end api call, continue in
    });
  };

  const getURL = (document) => {
    return new Promise(async (resolve, reject) => {
      $axiosInst
        .get("open1process/files/" + document.versionedFileId, {
          params: {
            registeredOrganizationId: selectedCase.orgId,
            issuerQuintuplet,
          },
        })
        .then(function (response) {
          if (response.status !== 200) {
            console.log(
              "Looks like there was a problem. Status Code: " + response.status
            );
            reject();
          } else {
            console.log(response.data.data.currentVersion.url);
            console.log(response.data.data);
            let urltemp = response.data.data.currentVersion.url;
            if (process.env.BASE_URL.indexOf("https://") !== -1) {
              // this is a secure connection, convert the url to https:
              urltemp = urltemp.replace("http://", "https://");
            }
            let result = {
              docId: document.versionedFileId,
              versionFileId: response.data.data.currentVersion.fileId,
            };
            resolve(result);
          }
        })
        .catch(function (err) {
          console.log("Fetch Error :-S", err);
          reject(err);
        });
    });
  };

  // const createDownloadLinkOld = (res) => {

  //   console.log("calling create downloadLink....");
  //   //openModal = true;
  //   //response needs to be an arraybuffer, in order to build the blob url
  //   return new Promise(async (resolve, reject) => {
  //     $axiosInst
  //       .get(res.url, { responseType: "arraybuffer", transformRequest: (data, headers) => {
  //         delete headers['SessionID'];
  //         return data;
  //         }
  //       })
  //       .then(function (response) {
  //         if (response.status !== 200) {
  //           console.log(
  //             "Looks like there was a problem. Status Code: " + response.status
  //           );
  //           reject();
  //         } else {
  //           console.log(response);
  //           //create the download URL, set the type of file it's sending
  //           let downloadLink = URL.createObjectURL(
  //             new Blob([response.data], {
  //               type: response.headers["content-type"],
  //             })
  //           );
  //           let result = {
  //             docId: res.docId,
  //             downloadLink: downloadLink,
  //           };
  //           resolve(result);
  //         }
  //       })
  //       .catch(function (err) {
  //         console.log("Fetch Error :-S", err);
  //         reject(err);
  //       });
  //   });

  // };
  const addPropertyToDocument = (result) => {
    //create the download URL, set the type of file it's sending
    //let downloadLink = URL.createObjectURL(new Blob([response.data.data.currentVersion.url], {type: response.headers["content-type"]}));
    //add download link propery to document
    let filter = selectedCase.documentsUploaded.filter(
      (doc) => result.docId === doc.versionedFileId
    );
    console.log(filter);
    if (filter.length) {
      filter[0]["downloadLink"] = result.downloadLink;
    } else filter["downloadLink"] = result.downloadLink;

    console.log(selectedCase.documentsUploaded);
  };
  const getUser = () => {
    return new Promise(async (resolve, reject) => {
      try {
        await $axiosInst
          .get("externalEntities/" + $params.id)
          .then(function (response) {
            if (response.status !== 200) {
              console.log(
                "Looks like there was a problem. Status Code: " +
                  response.status
              );
              userFound = false;
              loading = false;
              reject();
            } else {
              //If status OK, see if we have errors
              console.log(response.data);
              if (response.data.errors.length > 0) {
                console.log("Error" + ": " + response.data.errors);
                // add more actions...
                userFound = false;
                loading = false;
                reject();
              } else {
                //no errors, move to next and final step
                console.log("Success!");
                userFound = true;
                loading = false;
                user = response.data.data;
                console.log(response.data.data);
                //sort requests
                user.requests = user.requests.sort(
                  (a, b) => parseInt(b.id) - parseInt(a.id)
                );
                user.requests = user.requests.map((r) => {
                  if (r.status && r.status.length && r.status[0] == "!") {
                    r.warning = true;
                    r.status = r.status.substring(1);
                  } else {
                    r.warning = false;
                  }
                  return r;
                });

                user.requests.forEach((element) => {
                  element["open"] = false;
                });

                resolve(user);
              }
            }
          });
      } catch (err) {
        console.log("Fetch Error :-S", err);
        reject(err);
      }
    });
  };
  
  let updatingInfo = false;
  
  const updateUserInfoHelper = async () => {
    updatingInfo = true;
    try {
      await updateUserInfo(user.taxId);
      updateMessage = "Επιτυχής αποθήκευση";
      updatingInfo = false;
    }
    catch {
      updateMessage = "Παρουσιάστηκε πρόβλημα. Παρακαλώ προσπαθήστε αργότερα.";
      updatingInfo = false;
    }
  }

  onMount(() => {
    // if(!$loggedIn) $goto("/");
    // if($profile.id!=$params.id) $goto("/");
    getUser().then((userdata) => {
      //modify user cookie with additional data
      let cookieData = getCookie("gsisAuth");
      if (cookieData) {
          // add data 
          cookieData['info']['uid'] = userdata.id;
          // modify
          modifyCookie("gsisAuth", cookieData, false);
        }
      // if user profile info for mathername and fathername is missing, pull that from taxis login info (cookie)
      console.log("inside get user onmount", user)
      //field types 
      const fieldTypes = new Map($userDetails.map((obj) => [obj.id, obj.type]));
      //map content
      const userDetailsContent = ((user.additionalInfoDTO !== null) &&  (Object.keys(user.additionalInfoDTO).length > 0)) ? Object.values(user.additionalInfoDTO) : $userDetails;
      
      $userDetails = userDetailsContent.map(detail => {
        let matchingStoreItem = $userDetails.find(item => item.id === detail.id);
        return {
          "id": detail.id,
          "title": matchingStoreItem.title,
          "description": matchingStoreItem.description,
          "value": detail.value,
          "type": matchingStoreItem.type,
          "isObligatory": matchingStoreItem.isObligatory,
          "isLegalEntity": matchingStoreItem.isLegalEntity
        }});

      //((user.additionalInfoDTO !== null) &&  (Object.keys(user.additionalInfoDTO).length > 0)) ? Object.values(user.additionalInfoDTO) : $userDetails;
      //map field types to field
      $userDetails = $userDetails.map( obj => ({ ...obj, type: fieldTypes.get(obj.id) }));
      if (!$userDetails.onomamiteras || !$userDetails.onomapatera) {
        let gsisAuth = getCookie("gsisAuth");
        console.log(gsisAuth);
        if (gsisAuth) {
          const posmothername = $userDetails.map(e => e.id).indexOf('onomamiteras');
          const posfathername = $userDetails.map(e => e.id).indexOf('onomapatera');
          $userDetails[posmothername].value = gsisAuth.info.mothername;
          $userDetails[posfathername].value = gsisAuth.info.fathername;
          $userDetails = $userDetails;
        }
      }
      //set user documents
      $userDocuments = userdata.userDocuments;
      // searchWithCriteria(searchCriteria);
    });
    //getOrgInfo();
  });

  // -------------------------------------FOR RESUBMISSION ------------------------------------------------------------
  let additionalDocuments = [];
  let allDocsUploaded = [];
  let isFormValid = false;

  const validateForm = () => {
    console.log("running validateForm");
    let filecounter = 0;
    let newArray = [
      ...serviceRequestedFiles,
      ...additionalDocuments,
    ];
    console.log("NEW ARRAY", newArray);

    newArray.forEach((item) => {
      console.log(item.fileTitle, item.file);

      if (item.file !== null && item.file !== undefined &&  item.file.length) {
        //a file has been uploaded
        filecounter++;
      }
    });

    if (filecounter === 0) isFormValid = false;
    //form has no files, prevent resubmission
    else {
      isFormValid = true;
      //if files exist, check for errors
      errors = checkFiles(newArray);
      if (errors.length > 0) isFormValid = false;
      else isFormValid = true;
    }

    console.log(filecounter);
  };

  const addExtraDocument = () => {
    additionalDocuments.push({
      file: null,
      fileTitle: "new document" + (additionalDocuments.length + 1),
      mapToVariableName: "additional" + (additionalDocuments.length + 1),
      fileDescription: "new description",
      hint: null,
      versionedFileId: null,
    });

    // hasErrors.push(false);
    // hasErrors = hasErrors;
    additionalDocuments = additionalDocuments;
  };

  const deleteFileFromList = (event, list, index) => {
    console.log("GOT INSIDE DELETE");

    list.forEach((file) => {
      if (file.fileTitle === event.detail.title) {
        file.file = null;
        file = file;
      }
    });

    errors = checkFiles(list);
    validateForm();
  };

  const resetFileList = (list) => {
    console.log(list);
    list.forEach((file) => {
      if (file.file) file.file = null;
    });
  };

  const resubmitToCase = async (registeredOrganizationId, processInstanceId, protocolNumber) => {
    //filter the documants, only submit those that have an uploaded file
    console.log(additionalDocuments);
    console.log( documentsNotUploadedToCase);
    console.log( serviceRequestedFiles);
    let newDocuments = [
      ...serviceRequestedFiles,
      ...additionalDocuments
    ];

    let dvDocRef = await findRelatedProtocolFromInstanceTags(registeredOrganizationId, processInstanceId);
    let dvGroupId = await findRelatedGroupIdFromInstanceTags(registeredOrganizationId, processInstanceId);
    let dvUserId = await findRelatedUserIdFromInstanceTags(registeredOrganizationId, processInstanceId);

    newDocuments = newDocuments.filter((doc) => {
      return doc.file && doc.file.length !== 0;
    });

    //call resubmission process from Tukanga and pass these arguments:
    console.log(
      "Resubmit to case: processInstance " +
        processInstanceId +
        "\nnewDocs " +
        newDocuments +
        "\nprotocolNumber " +
        protocolNumber
    );
    console.log("new docs: ", dvDocRef, dvGroupId, dvUserId, newDocuments);

    //upload files + start process instance
    processIsStarting = true;
    successfulResubmission = false;

    chainUploads(newDocuments).then((result) => {
      console.log(result);
      // chain uploads resolves with array [fileId, variableName, previousVersionId]
      return startProcess(result, dvDocRef, dvGroupId, dvUserId).then((resolved_object) => {
        console.log(resolved_object);
        //processNum = resolved_processId;
        // return createUserRequest(documentsUploaded, resolved_processId);
        // return startProcess(result).then((resolved_object) => {
        resetFileList(selectedCase.documentsUploaded);
        resetFileList(documentsNotUploadedToCase);
        return createUserRequest(
          newDocuments,
          resolved_object.instanceId,
          resolved_object.businessKey
        );        
      });
    });

    resubmissionMode = false;
  };

  const fileUpload = async (filedata, vars_values_array) => {
    let url = "open1process/files";

    console.log(filedata);
    //  filedata =
    // {
    //   file: FileList {0: File, length: 1}
    //   fileDescription: "Φωτοτυπία ταυτότητας"
    //   fileTitle: "Φωτοτυπία ταυτότητας"
    //   mapToVariableName: "IDphoto"
    //   obligatory: false
    //   templateFileURI: null
    // }
    let formData = new FormData();
    if (filedata && filedata.file && issuerQuintuplet) {
      formData.append("file", filedata.file[0]);
      formData.append("alias", filedata.fileTitle);
      formData.append("orgUUId", issuerQuintuplet.split(":")[0]);
      formData.append("orgStructureUUId", issuerQuintuplet.split(":")[1]);
      formData.append("orgUnitUUId", issuerQuintuplet.split(":")[2]);
      formData.append("roleUUId", issuerQuintuplet.split(":")[3]);
      formData.append("personUUId", issuerQuintuplet.split(":")[4]);
    }

    formData.append("registeredOrganizationId ", selectedOrgDTO.id);

    //if there is a previous version, don't add it to the query params, keep it in another array instead
    let previousVersionId = null;
    if (filedata.versionedFileId) previousVersionId = filedata.versionedFileId;

    //console.log(url);
    return new Promise(async (resolve, reject) => {
      try {
        const res = await $axiosInst.post(url, formData, {
          transformRequest: (formData, headers) => {
            return formData;
          },
        });
        console.log(res.data);
        console.log(res.status);
        if (res.status === 200) {
          console.log("successful upload");
          // =================
          //set documentsUploadedArray which will be sent to the user's profile after the process instnce is started
          // let doc = {
          //   fileTitle: filedata.fileTitle,
          //   fileDescription: filedata.fileTitle,
          //   versionedFileId: res.data.data.versionedFileId,
          // };
          // documentsUploaded.push(doc);
          // ===============
          vars_values_array.push({
            value: res.data.data.versionedFileId,
            var: filedata.mapToVariableName,
            previousVersionId: previousVersionId,
          });
          vars_values_array = vars_values_array;
          resolve(res.data.data); //we need the fileId to start a new process later
        } else {
          reject("something went wrong");
        }
      } catch (e) {
        console.log(e);
        reject(e);
      }
    });
  };

  const chainUploads = async (files_array) => {
    //resolves all file uploads. By the end of it, the [{id, var}] array is complete, and ready to be used by startProcess and updateVars

    var ids = [];
    var promises = [];
    var fileIds;
    var i;

    //get uploaded files
    let filter = files_array.filter((fileData) => fileData.file != null);

    console.log("CHAIN UPLOADS FILTER: ", filter);

    return new Promise(async (resolve, reject) => {
      for (i = 0; i < filter.length; i++) {
        promises.push(fileUpload(filter[i], ids));
        promises = promises;
        console.log("resolving file " + i);
      }

      Promise.all(promises)
        .then((results) => {
          console.log("Resolved all files " + JSON.stringify(results));
          console.log(ids);
          resolve(ids);
        })
        .catch((e) => {
          // handle errors here
          reject(e);
        });
    });
  };

  let processIsStarting = false;
  let errorWithProcess = false;
  let successfulResubmission = false;
  let resubmissionData = {
    protocolNumber: null,
    processInstanceIdToResubmit: null,
    variableNameToPutCurrentPid: "submitFROM",
    resubmissionSignal: "__resubmit",
    resubmissionRelationshipList: [],
  };

  $: if (resubmissionMode) {
    resubmissionData.protocolNumber = selectedCase.protocolNumber;
    resubmissionData.processInstanceIdToResubmit =
      selectedCase.processInstanceId;
    toggleRequirement(serviceRequestedFiles);
  }

  const createUserRequest = async (
    uploads_data,
    processInstanceId,
    business_key
  ) => {
    //the data comes from file upload, it's fileIDs each associated with user uploads
    //we will then set values from service and onBehalfOf info
    //if business_key is null, we set nothing there
    //the requests's userId will be set from api
    let today = new Date();
    let date =
      today.getDate() +
      "-" +
      (today.getMonth() + 1) +
      "-" +
      today.getFullYear();
    let time =
      today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
    let dateTime = date + " " + time;

    //find local dosuments to be uploaded along with uploads_data
    let localUploads = [];

    // for (let i = 0; i < user.userDocuments.length; i++) {
    //   // console.log(user.userDocuments[i], localFiles, localFileIds, localFileIds.includes(user.userDocuments[i].versionedFileId));
    //   let target = null;
    //   if (localFileIds.includes(user.userDocuments[i].versionedFileId))
    //     target = localFiles.find(
    //       (item) =>
    //         item.file[0].versionedFileId ===
    //         user.userDocuments[i].versionedFileId
    //     );
    //   if (target) {
    //     localUploads.push({
    //       fileTitle: target.fileTitle,
    //       fileDescription: target.fileDescription,
    //       versionedFileId: user.userDocuments[i].versionedFileId,
    //     });
    //     localUploads = localUploads;
    //   }
    // }

    //set some attributes to request body first
    let userRequestContextDTO = {
      attributesDTO: {
        emailAddress: user.email,
        firstName: user.physicalEntityDTO.firstName,
        lastName: user.physicalEntityDTO.lastName,
        phoneNumber: user.additionalInfoDTO && user.additionalInfoDTO.thl ? user.additionalInfoDTO.thl.value : null,
        afm: user.taxId
      },
      requestDTO: {
        documentsProduced: [],
        documentsUploaded: [],
        orgTitle: selectedOrgDTO.title,
        orgId: selectedCase.orgId,
        date: dateTime,
        processInstanceId: processInstanceId,
        serviceName: "RESUBMISSION",
        serviceUuid: selectedOrgDTO.resubmissionServiceUuid,
        businessKey: business_key,
        status: "Σε εξέλιξη",
        protocolNumber: null,
      },
      taxId: user.taxId,
    };
    console.log(userRequestContextDTO);
    await createNewUserRequest(userRequestContextDTO);
    return;
  };

  const startProcess = async (data_array, relatedprotocolId, relatedProtocolGroupId, relatedProtocolUserId) => {
    //the data_array comes from file upload, it's fileIDs each associated with a variable value and previous version (not yet asscociated in open1Process)

    //this object holds the values needed for updateProcessVars which will be called after startProcess resolves
    let resolved = { processId: null, vars_values_array: [] };

    //push values regarding file variables
    resolved.vars_values_array.push(...data_array);

    //only pass values (ids) from uploaded files array (data_array, that is)
    let ids = data_array.map((el) => el.value);

    //set some attributes to request body first

    let request_body = {
      associatedFiles: ids,
      businessKey:
        "ΕΠΑΝΥΠΟΒΟΛΗ ΣΧΕΤΙΚΟΥ " + selectedCase.protocolNumber +
        " > " +
        selectedCase.serviceName +
        " ( " +
        user.physicalEntityDTO.firstName +
        " " +
        user.physicalEntityDTO.lastName +
        " )",
      // comments: emailVerificationInfo.comments,
      onBehalfOfDTO: {
        emailAddress: user.email,
        firstName: user.physicalEntityDTO.firstName,
        lastName: user.physicalEntityDTO.lastName,
        phoneNumber: user.additionalInfoDTO && user.additionalInfoDTO.thl ? user.additionalInfoDTO.thl.value : null,
        afm: user.taxId,
      },
      priority: "normal",
      registeredOrganizationId: selectedOrgDTO.id,
      serviceId: 0,
      variables: {},
    };
    // //set file variables hashmap
    // resolved.vars_values_array.forEach((entry) => {
    //   request_body.variables[entry.var] = entry.value;
    // });

    //add variable for related protocol ref data
    if (relatedprotocolId) request_body.variables[process.env.DATAVERSE_DOC_REF_VARIABLE] = relatedprotocolId;
    if (relatedProtocolGroupId) request_body.variables[process.env.DATAVERSE_GROUP_ID_VARIABLE] = relatedProtocolGroupId;
    if (relatedProtocolUserId) request_body.variables[process.env.DATAVERSE_USER_ID_VARIABLE] = relatedProtocolUserId;
    console.log("STRINGIFY VARS: ", JSON.stringify(request_body.variables));
    // request_body.variables[selectedOrgDTO.variableNametoPutPid] = selectedCase.processInstanceId;
    // request_body.variables['protocolNumVar'] = selectedCase.protocolNumber;

    console.log("request_body ", request_body);

    return new Promise(async (resolve, reject) => {
      try {
        const res = await $axiosInst.post(
          "open1process/processes/start",
          request_body,
          {
            params: {
              serviceIssuer: issuerQuintuplet,
              serviceUuid: selectedOrgDTO.resubmissionServiceUuid,
              isResubmission: true,
            },
          }
        );
        console.log(res.data);
        console.log(res.status);
        if (res.status === 200) {
          {
            //If status OK, see if we have errors
            console.log(res.data);
            if (res.data.errors.length > 0) {
              console.log("An error occured" + ": " + res.data.errors);
              // add more actions...
              errorWithProcess = true;
              successfulResubmission = false;
              processIsStarting = false;
              reject("something went wrong");
            } else {
              //no errors
              console.log("Success!");
              errorWithProcess = false;
              processIsStarting = false;
              successfulResubmission = true;
              //resolved.processId = res.data.data[0].instanceId;
              //resolves sending the object with process instance Id, and the fileIDs-vars association array to updateProcessVars
              resolve(res.data.data[0]);
              console.log(res.data.data);
            }
          }
        } else {
          errorWithProcess = true;
          processIsStarting = false;
          successfulResubmission = true;
          reject("something went wrong");
        }
      } catch (e) {
        reject(e);
      }
    });
  };
</script>

{#if $loggedIn && $profile.id == $params.id}
  <div class="container app-container mt-6 p-0">
    <!-- <div class="panel"> -->
    <div class="container has-text-centered">
      <h2 class="is-size-3-desktop is-size-5 px-5">
        {#if userFound}
          {user.physicalEntityDTO.firstName}&nbsp;{user.physicalEntityDTO
            .lastName}{/if}
      </h2>
    </div>
    <!-- <p class="panel-heading"> -->

    <!-- </p> -->

    {#if userFound}
      <div class="mt-4 tabs mb-0 is-fullwidth">
        <ul role="tablist">
          <li
            role="tab"
            on:click={() => {
              activeMenu = 1;
            }}
            class={activeMenu === 1 ? "is-active" : ""}
          >
            <a>
              <!-- <span class="icon is-medium">
            <Fa class="mx-1" icon={faFolder} aria-hidden="true" />
          </span> -->
              Οι υποθέσεις μου
            </a>
          </li>
          <li
            role="tab"
            on:click={() => {
              activeMenu = 2;
            }}
            class={activeMenu === 2 ? "is-active" : ""}
          >
            <a>
              <!-- <span class="icon is-medium">
            <Fa class="mx-1" icon={faUser} aria-hidden="true" />
          </span> -->
              <span>Το προφίλ μου</span>
            </a>
          </li>
          <li
            role="tab"
            on:click={() => {
              activeMenu = 3;
            }}
            class={activeMenu === 3 ? "is-active" : ""}
          >
            <a>
              <!-- <span class="icon is-medium">
            <Fa class="mx-1" icon={faUser} aria-hidden="true" />
          </span> -->
              <span>Τα έγγραφά μου</span>
            </a>
          </li>
        </ul>
      </div>
    {/if}

    <div class="px-4 mt-0">
      <!-- <div class="column is-5 px-6 mx-5">  -->

      <!-- svelte-ignore a11y-no-noninteractive-tabindex -->
      <div class="column" role="tabpanel" tabindex="0">
        {#if userFound}
          {#if activeMenu === 3}
            {#if loading}
              <div class="is-size-5-mobile is-size-5 has-text-centered">
                <Spinner
                  size="100"
                  speed="750"
                  color="rgba(0, 255, 0, 0.3)"
                  thickness="5"
                  gap="40"
                />
              </div>
            {:else}
              <UserDocumentsPagination bind:userDocuments={user.userDocuments} bind:userId={user.id} bind:userTaxId={user.taxId}/>
            {/if}
          {/if}
          {#if activeMenu === 2}
            <div class="save-button-wrapper mx-12 mt-4 ">
              <div class="columns is-align-items-center">
                  <div class="column is-four-fifths">  
                  </div>
                  <div class="column">
                    <button
                      class="button {updatingInfo ? 'is-loading ' : ''} is-medium is-link has-background-link-dark is-size-5-desktop is-size-6"
                      on:click={updateUserInfoHelper}
                      >
                        <SaveIcon size="24"/>&nbsp;&nbsp;Αποθήκευση
                    </button>
                  </div>
              </div>
            </div>
            <div class="columns">
              <div class="column is-half">
                <div class="field mt-0">
                  <div class="label is-normal">
                    <label class="label">
                      <!-- Last Name -->
                      Επώνυμο
                    </label>
                  </div>
                  <div class="field-body">
                    <div class="field">
                      <div class="control">
                        <input
                          disabled
                          value={user.physicalEntityDTO.lastName}
                          class="input"
                          type="text"
                          placeholder=""
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div class="field mt-5">
                  <div class="label is-normal">
                    <label class="label">
                      <!-- Name -->
                      Όνομα
                    </label>
                  </div>
                  <div class="field-body">
                    <div class="field mt-0">
                      <div class="control">
                        <input
                          disabled
                          value={user.physicalEntityDTO.firstName}
                          class="input"
                          type="text"
                          placeholder=""
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div class="field mt-5">
                  <div class="label is-normal">
                    <label class="label">e-mail</label>
                  </div>
                  <div class="field-body">
                    <div class="field mt-0">
                      <div class="control">
                        <input
                          disabled
                          value={user.email}
                          class="input"
                          type="text"
                          placeholder=""
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div class="field mt-5">
                  <div class="label is-normal">
                    <label class="label">ΑΦΜ</label>
                  </div>
                  <div class="field-body">
                    <div class="field mt-0">
                      <div class="control">
                        <input
                          disabled
                          value={user.taxId}
                          class="input"
                          type="text"
                          placeholder=""
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="column is-half">
                  {#each $userDetails as userDetail, i}
                  <!-- {JSON.stringify(userDetail)} -->
                      <Formfield
                              hasMarginTop={i>0}
                              mappedToVariable={userDetail.id}
                              locked={false}
                              showObligatory={false}
                              bind:value={userDetail.value}
                              label={userDetail.title}
                              description={userDetail.description}
                              type={userDetail.type}
                      />
                  {/each}
              </div>
            </div>
          {/if}
          <!-- -------------------------------------------------------------------------------------------------------------------------------------------------------- -->
          {#if activeMenu === 1}

            <!-- SEARCHBAR ------------------------------------------ -->
            <div class="mx-12 my-4">
              <Search
                items={user.requests}
                filtersArray={[
                  "serviceName",
                  "businessKey",
                  "orgTitle",
                  "processInstanceId",
                  "protocolNumber",
                  "status",
                ]}
                on:ready={(e) => {
                  console.log("search says it's ready");
                  filteredResults = e.detail.results;
                  //close all open requests
                  toggle(-1);
                  loadingSearch = false;
                }}
                on:loading={() => {
                  loadingSearch = true;
                }}
              />
            </div>
            <!-- /SEARCHBAR ------------------------------------------ -->


            {#if loading}
              <div class="is-size-5-mobile is-size-5 has-text-centered">
                <Spinner
                  size="100"
                  speed="750"
                  color="rgba(0, 255, 0, 0.3)"
                  thickness="5"
                  gap="40"
                />
              </div>
            {:else if user.requests && user.requests.length > 0}
              <table class="table is-fullwidth is-narrow responsive-table mt-3">
                <thead
                  style="position:sticky; top:0rem; z-index: 1;"
                  class="is-hidden-mobile rounded-white"
                >
                  <tr>
                    <th class="has-text-centered" scope="col" colspan="2">
                      <div class="" aria-hidden="true">Υπόθεση</div>
                      <div class="is-sr-only">Αριθμός και τίτλος υπόθεσης</div>
                    </th>

                    <!-- <th class="has-text-centered">
                    <div class="">Υπηρεσία</div>
                  </th> -->

                    <th class="has-text-centered" scope="col" colspan="1">
                      <div class="">Κατάσταση</div>
                    </th>

                    <th class="has-text-centered" scope="col" colspan="1">
                      <div class="">Αριθμός Πρωτοκόλλου</div>
                    </th>

                    <th class="has-text-centered" scope="col" colspan="1">
                      <div class="">Φορέας</div>
                    </th>

                    <th class="has-text-centered" scope="col" colspan="1">
                      <div class="">Ημερομηνία αίτησης</div>
                    </th>

                    <th scope="col" colspan="1">&nbsp;</th>
                  </tr>
                </thead>
                <tbody>
                  {#if loadingSearch}
                    <tr class="is-mobile has-text-centered">
                      <td
                        colspan="12"
                        class="has-text-centered has-text-centered-mobile"
                      >
                        <div class="stage">
                          <Spinner
                            size="100"
                            speed="750"
                            color="rgba(0, 255, 0, 0.3)"
                            thickness="5"
                            gap="40"
                          />
                        </div>
                      </td>
                    </tr>
                  {:else if filteredResults.length > 0}
                    {#each filteredResults as request, i}
                      <tr
                        on:click={() => {
                          toggle(i);
                          selectedCase = filteredResults[i];
                          calledCrosscheck = false;
                          if (selectedOrgDTO && selectedOrgDTO.resubmissionServiceUuid) reset();
                        }}
                        aria-expanded={filteredResults[i].open}
                        style="width:100%"
                        class="my-hoverable is-mobile is-vcentered is-size-5-desktop is-size-6-tablet has-text-weight-medium is-size-7-mobile p-4 has-text-left"
                        class:has-background-danger-light={request.warning}
                      >
                        <td
                          class="is-size-5-desktop is-size-6-tablet is-size-7-mobile has-text-centered p-3 pt-5"
                        >
                          <div
                            class="is-hidden-tablet has-text-weight-semibold"
                          >
                            Υπόθεση
                          </div>
                          <span style="color: grey">
                            {request.processInstanceId
                              ? request.processInstanceId
                              : "Δεν έχει οριστεί αριθμός υπόθεσης"}
                          </span>
                        </td>

                        <td
                          class="is-size-5-desktop is-size-6-tablet is-size-7-mobile has-text-centered p-3 pt-5"
                        >
                          <!-- style="--title-string: 'Υπηρεσία';" -->
                          <div
                            class="is-hidden-tablet has-text-weight-semibold"
                          >
                            Υπηρεσία
                          </div>
                          {request.businessKey
                            ? request.businessKey
                            : request.serviceName}
                        </td>

                        <td
                          class="is-size-5-desktop is-size-6-tablet is-size-7-mobile has-text-centered p-3 pt-5"
                        >
                          <!-- style="--title-string: 'Κατάσταση';" -->
                          <div
                            class="is-hidden-tablet has-text-weight-semibold"
                          >
                            Κατάσταση
                          </div>
                          {#if request.warning}
                            <Fa
                              class="has-text-danger"
                              icon={faExclamationTriangle}
                              size="lg"
                              aria-hidden="true"
                            />
                          {/if}
                          {request.status}
                        </td>

                        <td
                          class="is-size-5-desktop is-size-6-tablet is-size-7-mobile has-text-centered p-3 pt-5"
                        >
                          <!-- style="--title-string: 'Αρ. Πρωτοκόλλου';" -->
                          <div
                            class="is-hidden-tablet has-text-weight-semibold"
                          >
                            Αριθμός Πρωτοκόλλου
                          </div>
                          {request.protocolNumber
                            ? request.protocolNumber
                            : "-"}
                          <!-- Δεν έχει οριστεί αριθμός πρωτοκόλλου -->
                        </td>

                        <td
                          class="is-size-5-desktop is-size-6-tablet is-size-7-mobile has-text-centered p-3 pt-5"
                        >
                          <!-- style="--title-string: 'Φορέας';" -->
                          <div
                            class="is-hidden-tablet has-text-weight-semibold"
                          >
                            Φορέας
                          </div>
                          {request.orgTitle}
                        </td>

                        <td
                          class="is-size-5-desktop is-size-6-tablet is-size-7-mobile has-text-centered p-3 pt-5"
                        >
                          <!-- style="--title-string: 'Ημ. Αίτησης';" -->
                          <div
                            class="is-hidden-tablet has-text-weight-semibold"
                          >
                            Ημερομηνία αίτησης
                          </div>
                          {moment(
                            request.date.split(" ")[0],
                            "DD-MM-YYYY"
                          ).format("DD/MM/YYYY")}
                          {moment(request.date.split(" ")[1], "H:m:s").format(
                            "HH:mm:ss"
                          )}
                          <!-- {request.date} -->
                        </td>

                        <td
                          class="is-size-5-desktop is-size-6-tablet is-size-7-mobile has-text-link has-text-centered p-3 pt-5"
                        >
                          <!-- style="--title-string: 'Ημ. Αίτησης';" -->
                          <span
                            class="is-hidden-tablet has-text-weight-semibold"
                          >
                            Δείτε περισσότερα...
                          </span>
                          <span
                            class="is-hidden-mobile has-text-weight-semibold"
                          >
                            <svg
                              class:svg-turned={user.requests[i].open &&
                                selectedCase == request}
                              width="20"
                              height="20"
                              fill="none"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-width="2"
                              viewBox="0 0 24 24"
                              stroke="currentColor"
                            >
                              <path d="M9 5l7 7-7 7" />
                            </svg>
                          </span>
                        </td>
                      </tr>

                      {#if user.requests[i].open && selectedCase == request}
                        {#if !ready}
                          <tr>
                            <td colspan="7" class="p-0">
                              <div
                                class="is-size-5-mobile is-size-5 has-text-centered"
                              >
                                <Spinner
                                  size="100"
                                  speed="750"
                                  color="rgba(0, 255, 0, 0.3)"
                                  thickness="5"
                                  gap="40"
                                />
                              </div>
                            </td>
                          </tr>
                        {:else}
                          <tr>
                            <td
                              colspan="7"
                              class:has-background-danger-light={selectedCase.warning}
                              class="p-4"
                            >
                              <div
                                style="border-radius: 5px;"
                                in:slide={{ duration: 300 }}
                              >
                                <!-- <div class="columns"> -->
                                <section class="my-3 py-3">
                                  {#if processIsStarting}
                                    <div class="has-text-centered mt-5">
                                      Πραγματοποιείται επανυποβολή....
                                      <div class="is-size-4-mobile is-size-3">
                                        <Spinner
                                          size="100"
                                          speed="750"
                                          color="rgba(0, 255, 0, 0.3)"
                                          thickness="5"
                                          gap="40"
                                        />
                                      </div>
                                    </div>
                                  {:else if errorWithProcess && !successfulResubmission}
                                    <div
                                      in:fade|local
                                      class="has-text-centered"
                                    >
                                      <div class="is-size-4-mobile is-size-3">
                                        <Fa
                                          icon={faFrown}
                                          size="4x"
                                          aria-hidden="true"
                                        />
                                      </div>
                                      <div class="columns is-centered mt-5">
                                        <div class="column">
                                          <div
                                            class="is-size-6-mobile is-size-5"
                                          >
                                            Παρουσιάστηκε πρόβλημα κατά την
                                            επανυποβολή.
                                          </div>
                                          <div
                                            class="is-size-6-mobile is-size-5"
                                          >
                                            Παρακαλώ προσπαθήστε ξανά.
                                          </div>
                                        </div>
                                      </div>
                                      <div class="is-size-4-mobile is-size-3">
                                        <button
                                          class="button is-link is-size-5-desktop is-size-6"
                                          on:click={reset}>OK</button
                                        >
                                      </div>
                                    </div>
                                  {:else if !errorWithProcess && successfulResubmission}
                                    <div
                                      in:fade|local
                                      class="has-text-centered mt-5"
                                    >
                                      <div class="has-text-success">
                                        <CheckIcon size="150" />
                                      </div>
                                      <div class="columns is-centered mt-5">
                                        <div class="column">
                                          <div
                                            class="is-size-6-mobile is-size-5"
                                          >
                                            H επανυποβολή επισυναπτόμενων
                                            αρχείων πραγματοποιήθηκε επιτυχώς!
                                          </div>
                                        </div>
                                      </div>
                                      <div>
                                        <button
                                          style="white-space: normal;"
                                          class="button is-link is-size-5-desktop is-size-6-mobile"
                                          on:click={reset}>ΟΚ</button
                                        >
                                      </div>
                                    </div>
                                  {:else if ready && selectedCase.documentsUploaded && selectedCase.documentsUploaded.length > 0}
                                    <div class="level mb-4">
                                      <div class="level-left">
                                        <h2 class="subtitle is-size-5 mb-0">
                                          Επισυναπτόμενα αρχεία
                                        </h2>
                                        
                                        {#if selectedOrgDTO.resubmissionServiceUuid && !(selectedCase.status.toString() === "Σε εξέλιξη")}
                                          <button
                                            class="button is-link is-light ml-5"
                                            on:click={() => {
                                              if (resubmissionMode) {
                                                reset();
                                              } else {
                                                resubmissionMode =
                                                  !resubmissionMode;
                                              }
                                            }}
                                          >
                                            {resubmissionMode
                                              ? "Ακύρωση επανυποβολής"
                                              : "Επανυποβολή"}
                                          </button>
                                        {/if}
                                      </div>
                                    </div>

                                    <ul>
                                      {#if !resubmissionMode}
                                        {#each Object.entries(Object.groupBy(selectedCase.documentsUploaded, doc => doc.fileTitle)) as [key, value]}
                                          <li
                                            class="mt-5 mb-1"
                                            data-tooltip="tooltip with long text"
                                          >
                                          <p class="mb-2"><b>{key}</b></p>
                                          {#each value as upload, i}
                                            <!-- svelte-ignore a11y-missing-attribute -->
                                            <li
                                              class="mt-1 mb-1 ml-3"
                                              data-tooltip="tooltip with long text"
                                            >
                                              <!-- svelte-ignore a11y-click-events-have-key-events -->
                                              <a on:click={downloadFile(upload)}>
                                                <span class="my-icon">
                                                  <DownloadIcon size="1.5x" />
                                                </span>&nbsp;
                                                <b>
                                                  {(upload.fileAlias == null || upload.fileAlias == "") 
                                                    ? ((value.length && value.length > 1) ? upload.fileTitle + "(" + i.toString() + ")" : upload.fileTitle )
                                                    : upload.fileAlias}
                                                </b>
                                              </a>
                                            </li>
                                          {/each}                                              
                                          </li>                                         
                                        {/each}
                                        
                                      <!-- ---------------------------------------------------------------------------------------------------------------------------------------------------------- -->
                                      <!-- ---------------------------------------------------------------RESUBMISSION ---------------------------------------------------------------------------------->
                                      {:else if resubmissionMode}
                                        {#each serviceRequestedFiles as doc, j}
                                          <Formfield
                                            type="file"
                                            bind:value={
                                              serviceRequestedFiles[j].file
                                            }
                                            errors={errors &&
                                            errors.length > 0
                                              ? findErrors(
                                                  errors,
                                                  doc.mapToVariableName.toString()
                                                )
                                              : []}
                                            label={doc.fileTitle}
                                            hasTemplate={doc.templateFileURI !=
                                              null}
                                            templateFileURI={doc.templateFileURI}
                                            on:deletefile={(event) =>
                                              deleteFileFromList(
                                                event,
                                                allDocsUploaded
                                              )}                                            
                                            on:valueChanged={() => {
                                                validateForm();
                                                if (
                                                  !allDocsUploaded.includes(
                                                    serviceRequestedFiles[j]
                                                  )
                                                ) {
                                                  allDocsUploaded.push(
                                                    serviceRequestedFiles[j]
                                                  );
                                                  allDocsUploaded =
                                                    allDocsUploaded;
                                                }
                                              }}
                                          />
                                        {/each}
                                    
                                        {#if additionalDocuments && additionalDocuments.length > 0}
                                          {#each additionalDocuments as extradoc, k}
                                            <li class="mt-1 mb-1">
                                              <div class="level mb-0">
                                                <div
                                                  class="level-left field is-horizontal"
                                                >
                                                  <div
                                                    class="field-label is-normal"
                                                  >
                                                  <label class="label"
                                                    >Τίτλος</label
                                                  >
                                                  </div>
                                                  <div class="field-body">
                                                    <div class="field mt-0">
                                                      <p class="control">
                                                        <input
                                                          class="input"
                                                          bind:value={
                                                            additionalDocuments[
                                                              k
                                                            ].fileTitle
                                                          }
                                                        />
                                                      </p>
                                                    </div>
                                                  </div>
                                                </div>
                                              <div class="level-right" />
                                            </div>
                                            <Formfield
                                              type="file"
                                              bind:value={
                                                additionalDocuments[k].file
                                              }
                                              errors={errors &&
                                              errors.length > 0
                                                ? findErrors(
                                                    errors,
                                                    extradoc.mapToVariableName.toString()
                                                  )
                                                : []}
                                              label={extradoc.fileTitle}
                                              hasTemplate={extradoc.templateFileURI !=
                                                null}
                                              templateFileURI={extradoc.templateFileURI}
                                              on:valueChanged={() => {
                                                validateForm();
                                                if (
                                                  !allDocsUploaded.includes(
                                                    additionalDocuments[k]
                                                  )
                                                ) {
                                                  allDocsUploaded.push(
                                                    additionalDocuments[k]
                                                  );
                                                  allDocsUploaded =
                                                    allDocsUploaded;
                                                }
                                              }}
                                              on:deletefile={(event) =>
                                                deleteFileFromList(
                                                  event,
                                                  allDocsUploaded
                                                )}
                                              />
                                            </li>
                                          {/each}
                                        {/if}
                                        <button
                                            class="button mt-5 my-1"
                                            on:click={addExtraDocument}
                                          >
                                          <PlusIcon
                                            size="24"
                                          />&nbsp;&nbsp;Ανεβάστε επιπλέον
                                          αρχείο...
                                        </button>
                                      {/if}
                                      <!-- ---------------------------------------------------------------------------------------------------------------------------------------------------------- -->
                                      <!-- --------------------------------------------------------------- /RESUBMISSION ---------------------------------------------------------------------------------->
                                      <!-- {/if} -->
                                    </ul>
                                  {/if}
                                  {#if ready && selectedCase.documentsUploaded.length == 0 && selectedCase.documentsProduced.length == 0}
                                    <em
                                      >Χωρίς επισυναπτόμενα ή απαντητικά αρχεία</em
                                    >
                                  {/if}
                                </section>

                                {#if selectedCase.documentsProduced && selectedCase.documentsProduced.length > 0}
                                  <section class="my-3 py-3">
                                    <h2 class="subtitle is-size-5 mb-4">
                                      Απαντητικά Αρχεία
                                    </h2>
                                    <ul>
                                      {#each selectedCase.documentsProduced as doc, i}
                                        <li
                                          class="mt-5 mb-1"
                                          data-tooltip="tooltip with long text"
                                        >
                                          <a on:click={downloadFile(doc)}>
                                            <span class="my-icon">
                                              <DownloadIcon size="1.5x" />
                                            </span>&nbsp;
                                            <b>{doc.fileTitle}</b>
                                          </a>
                                        </li>
                                      {/each}
                                    </ul>
                                  </section>
                                {/if}

                                <!-- </div> -->
                                <footer>
                                  {#if resubmissionMode && !successfulResubmission}
                                    <button
                                      class="button is-link"
                                      class:is-loading={processIsStarting}
                                      disabled={!isFormValid}
                                      on:click={() => {
                                        resubmitToCase(
                                          selectedCase.orgId,
                                          selectedCase.processInstanceId,
                                          selectedCase.protocolNumber
                                        );
                                      }}
                                    >
                                      Επανυποβολή
                                    </button>
                                  {/if}
                                </footer>
                              </div>
                            </td>
                          </tr>
                        {/if}
                      {/if}
                    {/each}
                  {:else}
                    <tr class="is-mobile has-text-centered">
                      <td
                        colspan="12"
                        class="is-size-5-mobile is-size-5 has-text-centered p-4"
                      >
                        Η αναζήτησή σας δεν επέστρεψε αποτελέσματα!
                      </td>
                    </tr>
                  {/if}
                </tbody>
              </table>
            {:else}
              Δεν έχετε καταχωρισμένες υποθέσεις
            {/if}
            <!-- -------------------------------------------------------------------------------------------------------------------------------------------------------- -->
          {/if}
        {:else}
          <div class="is-size-5-mobile is-size-5 has-text-centered">
            <Spinner
              size="100"
              speed="750"
              color="rgba(0, 255, 0, 0.3)"
              thickness="5"
              gap="40"
            />
          </div>
        {/if}
      </div>
    </div>
  </div>
{:else}
  <div in:fade={{ delay: 1200 }} class="container pt-4 px-4 mt-6">
    <h2 class="is-size-4">
      Για να δείτε αυτή τη σελίδα χρειάζεται Σύνδεση με λογαριασμό TaxisNet.
    </h2>
    <button
      class="button is-link is-size-5-desktop is-size-6 mt-2"
      on:click={gotoClient}>Ξεκινήστε από την αρχή</button
    >
  </div>
{/if}

<style lang="scss">
  .rounded-white {
    border-radius: 8px;
    /* background: rgba(255,255,255,0.8); */
    background: white;
    background: linear-gradient(
      180deg,
      rgba(255, 255, 255, 1) 50%,
      rgba(255, 255, 255, 0) 100%
    );
    padding: 10px;
  }

  .margin-top-1 {
    margin-top: 1rem;
  }

  :global(.my-hoverable:hover) {
    cursor: pointer;
    background-color: #fafafa;
    /* box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px; */
    /* color: #2563eb; */
  }

  svg {
    transition: transform 0.2s ease-in;
  }

  .svg-turned {
    transition: transform 0.2s ease-in;
    transform: rotate(0.25turn);
  }

  .stage {
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    padding: 2rem;
    margin: 0 auto; /* or margin: 0 auto 0 auto */
    overflow: hidden;
  }

  .field {
    /* margin-top: 0px !important; */
  } 

  @media
    only screen and (max-width: 768px) {
      .save-button-wrapper {
        margin-bottom : 1.5rem;
      }
    }
</style>
